<template>
  <b-modal ref="modalFavorisRecette" size="xl" :title="'Favoris de la recette \'' + nomRecette + '\' pour l\'ingrédient \''  + ingredient.designation + '\''"
      ok-title="Fermer" 
      :ok-only="true"
    no-close-on-backdrop
    @show="initialiserModale()"> 

    <template slot="default">
      <div class="ml-1">
        <div class="row">
          <div class="col-2 small">Quantité demandée</div>
          <div v-if="ingredient.produitId" class="col-10 small">Article sélectionné pour substitution</div>
          <div v-else class="col-10 small">Ingrédient sélectionné</div>
        </div>
        <div class="row">
          <div class="col-2">
            <h5>{{ingredient.quantiteBesoinEnUC}} {{ingredient.uc}}</h5>
          </div>
          <div class="col-10">
            <h5>
              {{ingredient.produitId && ingredient.designation ? ingredient.designation.toUpperCase() : nomIngredient.toUpperCase()}}
              {{ingredient.marque ? ' - ' + ingredient.marque : ''}}
              {{ingredient.fournisseurId ? ' - ' + fournisseurNom(ingredient.fournisseurId) : ''}}<br />
              <span v-if="ingredient.prixUnitaire && ingredient.uc">({{ingredient.prixUnitaire}} € / {{ingredient.uc}}, prix total: {{(ingredient.quantiteBesoinEnUC * ingredient.prixUnitaire) | afficherPrix}})</span>
            </h5>
          </div>
        </div>
      </div>
      <div class="flex-start ml-1 mt-3 mb-1 small">Articles associés à l'ingrédient "{{nomIngredient}}"</div>
      <div>
        <div v-for="(article, iArticle) in articlesProduit(parProduit)" :key="'article' + iArticle" :id="'accordion' + iArticle">
      
          <div class="card">
            <div class="card-header flex-center-space-between">
              {{nomArticle(article.nom)}}
              
              <div class="flex-end">
                <span :v-tooltip="'Mieux-disant'" :class="['pl-3 pr-3 pt-1 pb-1', { 'meilleurPrixProduitAgap': totalPcbMinimal(article.produits) == mieuxDisantGeneral }]">{{ totalPcbMinimal(article.produits) | afficherPrix }}</span> 
                <div v-if="ingredient" class="flex-center-space-between">
                   <span class="ml-5">  
                    <i class="fa-star cursor-pointer" :class="articleEnFavori(recetteId, article) ? 'fas text-warning' : 'far'"
                      @click.prevent="changerFavori(recetteId, article)">
                    </i>
                  </span>
                </div>

              </div>
            </div>

            <div class="card-container">
                  <div class="card card-minimal">
                    <table class="table table-sm table-borderless text-center">
                      <colgroup>
                        <col>
                        <col width="30">
                        <col width="75">
                        <col width="160">
                        <col width="60">
                        <col width="90">
                        <col width="90">
                        <col width="40">
                      </colgroup>
                      <thead>
                        <th class="aligner-gauche">Désignation</th>
                        <th>FT</th>
                        <th>Réf.</th>
                        <th>Fournisseur</th>
                        <th>PCB</th>
                        <th>PU HT</th>
                        <th>Total HT</th>
                        <th></th>
                      </thead>
                    </table>
                    <hr class="mt-0 mb-0" />
                    <div class="table-body">
                      <table class="table table-sm table-borderless text-center">
                        <colgroup>
                          <col>
                          <col width="30">
                          <col width="75">
                          <col width="160">
                          <col width="60">
                          <col width="90">
                          <col width="90">
                          <col width="40">
                        </colgroup>
                        <tbody>
                          <tr v-for="(ligneArticle, iLigne) in article.produits" :key="'article' + iLigne" :class="[{ 'ligne-desactivee': ligneArticle.bloque }]"> 
                            <td class="aligner-gauche">{{ ligneArticle.designation }} - {{ ligneArticle.marque }} - {{ligneArticle.fournisseurId}}</td>
                            <td><BoutonFicheTechnique v-if="ligneArticle.urlFT" size="sm" :fournisseurId="ligneArticle.fournisseurId" :reference="ligneArticle.reference" :urlFT="ligneArticle.urlFT" /></td>
                            <td>{{ ligneArticle.reference }}</td>
                            <td>{{ fournisseurNom(ligneArticle.fournisseurId) }}</td>
                            <td>{{ ligneArticle.pcb }}</td>
                            <td>
                              <span :class="['pl-2 pr-2 pt-1 pb-1', { 'meilleurPrixArticleFournisseur': prixMinimal(article.produits) == ligneArticle.prixUnitaire }]">
                                {{ ligneArticle.prixUnitaire | afficherPrix }}
                              </span>
                            </td>
                            <td>
                              <span :class="['pl-2 pr-2 pt-1 pb-1', { 'meilleurPrixArticleFournisseur': totalPcbMinimal(article.produits) == totalPcb(ingredient.quantiteBesoinEnUC, ligneArticle.pcb, ligneArticle.prixUnitaire) }]">
                                {{ totalPcb(ingredient.quantiteBesoinEnUC, ligneArticle.pcb, ligneArticle.prixUnitaire) | afficherPrix }}
                              </span>
                            </td>
                            <td>
                              <i v-if="ingredient" class="fa-star cursor-pointer" :class="articleEnFavori(recetteId, article, ligneArticle) ? 'fas text-warning' : 'far'"
                                @click="changerFavori(recetteId, article, ligneArticle)">
                              </i> 
                            </td> 
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { connecteData } from '@/mixins/connecteData'
import { fournisseurs } from '@/mixins/fournisseurs'
import { tousArticlesPour } from '@/api/gpao/mercuriales'
import { mapGetters } from "vuex"
import { qtePCB } from '@/helpers/utils'
import BoutonFicheTechnique from '@/components/Divers/BoutonFicheTechnique'
import _ from "lodash"

export default {
  name: "ModalFavorisRecette",
  // props: {
  //   /*propIngredient: Object,
  //   small: Boolean,
  //   recette: Object,
  //   recettes: [],*/   
  // },
  components: { BoutonFicheTechnique },
  mixins: [fournisseurs, connecteData],
  data() {
    return {
      recette: {},
      ingredient: {},
      favorisModifies: false, // indique si on a modifié un favori
      article: {},
      mieuxDisantGeneral: 2.263158,
      articlesEnFavori: [],
      parProduit: [],
      nomRecette: "" 
    }
  },
  computed: {
    ...mapGetters("definitions", ["obtenirIngredient"]),
    nomIngredient() {
      return this.obtenirIngredient(this.ingredient?.ingredientId)?.nom || ""
    }
  },
  methods: {
    initialiserModale() {
      this.obtenirArticles(this.ingredient)
    },
    async obtenirArticles(ingredient) {  
      let response = await tousArticlesPour(this.etabCourantId, ingredient.ingredientId, ingredient.familleId, ingredient.grammage)
      let parProduit = {}
      for (let key in response.data.parProduit) {
          parProduit[key] = response.data.parProduit[key]
          parProduit[key].forEach(p => { p.familleId = response.data.familleId })
        }
      this.parProduit = parProduit
    },
    qtePcb(qte, pcb) {
      return qtePCB(qte, pcb)
    },
    totalPcb(qte, pcb, pu) {      
      return (qtePCB(qte, pcb) || pcb) * pu
    },
    totalPcbMinimal(produits) {    
      return produits.reduce((min, p) => this.totalPcb(this.ingredient.quantiteBesoinEnUC, p.pcb, p.prixUnitaire) < min ? this.totalPcb(this.ingredient.quantiteBesoinEnUC, p.pcb, p.prixUnitaire) : min, this.totalPcb(this.ingredient.quantiteBesoinEnUC, produits[0].pcb, produits[0].prixUnitaire))
    },
    prixMinimal(produits) {
      return (produits.reduce((min, p) => p.prixUnitaire < min ? p.prixUnitaire : min, produits[0].prixUnitaire));
    },
    articlesProduit(articles) {
      let retour = articles && Object.entries(articles).map(el => { return { nom: el[0], produits: el[1], produitId: el[0] } })
      return retour || []
    },
    nomArticle(id) {
      let retour = this.$store.state.produits?.produitsUtilisateur?.find(el => el.id === id)?.designation
      if (this.profilIsAdmin) {
        retour = retour + "   - " + id
      }
    
      return retour;
    },
    articleEnFavori(recetteId, article, ligneArticle) {
      let favoris = this.articlesEnFavori.filter(el => el.recetteId == recetteId && el.produitId == article.produitId && el.actif) || []
      if (ligneArticle?.fournisseurId)
        favoris = favoris.filter(el => el.fournisseurId == ligneArticle.fournisseurId)
      else
        favoris = favoris.filter(el => !el.fournisseurId)
      return favoris.first()
    },
    changerFavori(recetteId, article, ligneArticle) {
      let fav = this.articleEnFavori(recetteId, article, ligneArticle)
      if (fav?.actif) {
        // Favori actif => on le désactive
        fav.actif = false
      } else if (fav) {
        // Favori inactif => on l'active
        fav.actif = true
      } else {
        // Favori inexistant => on le crée
        this.articlesEnFavori.push({ id: 0, ingredientId: this.ingredient.ingredientId, produitId: article.produitId, recetteId: recetteId, fournisseurId: ligneArticle?.fournisseurId || null, actif: true, lectureSeule: false })
      }
      this.$emit('favorisChoisis',  { ingredientId: this.ingredient.ingredientId, articlesEnFavori: this.articlesEnFavori })
    },
    show(ingredient, favorisIngredientRecette) {
      if (ingredient) {
         this.ingredient = ingredient
         this.recetteId = ingredient.recetteId
         this.nomRecette = ingredient.nomRecette
      }

      this.articlesEnFavori = []
      if (favorisIngredientRecette) {
         this.articlesEnFavori = _.cloneDeep(favorisIngredientRecette)
      }
      
      this.$refs.modalFavorisRecette.show()
    },
    hide() {
      this.$refs.modalFavorisRecette.hide()
    }
  }
}
</script>